import { tsIoValidate } from "../../../../utils/general/generalUtils"
import {
    IValidatorDevicesData,
    ValidatorDevicesData,
} from "../../types/validatorInterface/validatorHomepageTypes"

export const validatorHomepageMapper = {
    /**
     * Maps the response from the Validator Homepage API to the IValidatorDevicesData interface.
     * @param response - The response from the API.
     * @returns The mapped object of type IValidatorDevicesData.
     */
    mapValidatorDevicesData: (response: unknown): IValidatorDevicesData => {
        const res = tsIoValidate<IValidatorDevicesData>(
            ValidatorDevicesData,
            response,
            "Error mapping Validator Homepage Devices Data"
        )
        return res
    },
}
